import mapButtonProps from './mapButtonProps';

export default function bodyTextsContainerMapper(componentsData) {
  const { photoTemplatesData, ...componentRest } = componentsData;

  let result;

  if (!photoTemplatesData) {
    result = componentsData;
  } else {
    result = {
      ...componentRest,
      photoTemplatesData: photoTemplatesData.map(data => ({
        ...data,
        icons: data.icons?.map(({ value }) => value),
      })),
    };
  }

  if (!result.photoTemplatesData.length) {
    delete result.photoTemplatesData;
  }

  if (!result.videoTemplatesData.length) {
    delete result.videoTemplatesData;
  }

  return mapButtonProps(result);
}
